import { AlertTriangle } from 'lucide-react';
import React from 'react';
import { Button } from './Button';
import { Modal } from './Modal';

interface ConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void> | void;
  title: string;
  message: string;
  isLoading?: boolean;
  confirmText?: string;
  cancelText?: string;
  tone?: 'danger' | 'default';
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  isLoading = false,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  tone = 'default',
}) => {
  const toneClasses =
    tone === 'danger'
      ? {
          icon: 'bg-red-100 text-red-600',
          confirmButton: 'bg-red-600 text-white hover:bg-red-700',
        }
      : {
          icon: 'bg-amber-100 text-amber-700',
          confirmButton: '',
        };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} size="md">
      <div className="space-y-6">
        <div className="flex items-start gap-4">
          <div
            className={`flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full ${toneClasses.icon}`}
          >
            <AlertTriangle size={22} />
          </div>
          <p className="pt-1 text-sm leading-6 text-gray-700">{message}</p>
        </div>

        <div className="flex justify-end gap-3 border-t border-gray-100 pt-4">
          <Button variant="outline" onClick={onClose} disabled={isLoading}>
            {cancelText}
          </Button>
          <Button
            onClick={onConfirm}
            isLoading={isLoading}
            className={toneClasses.confirmButton}
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
